import styled from "styled-components";
import googleIcon from "../images/search.svg";

const GoogleButton = styled.button`
  display: block;
  width: 100%;
  height: 46px;

  background-color: #ffffff;
  color: #484848;
  font-size: 1rem;
  font-weight: 500;
  border-radius: 3px;
  outline: none;
  border: none;
  cursor: pointer;

  background-image: url(${googleIcon});
  background-position: 20px center;
  background-size: 25px 25px;
  background-repeat: no-repeat;

  margin-bottom: 0.8rem;
  padding: 0;

  border: 1px solid #dfdfdf;

  &:hover {
    background-color: #f7f7f7;
  }
`;

export default GoogleButton;



// WEBPACK FOOTER //
// ./src/components/GoogleButton.jsx